import React, {Component} from "react"
import {get} from "lodash"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {CSSTransition, TransitionGroup} from "react-transition-group"

import ShowPopUp from "@irati/store/actions/ShowSuccessPopUp"
import {tooltip} from "@irati/ui/src/global/colors"
import Flex from "@irati/ui/src/Flex"
import {Body, H5} from "@irati/ui/src/Typography"

import Close from "../Close"
import PopUpWrapper from "./styled/PopUpWrapper"
import PopUp from "./styled/PopUp"
import Checkbox from "./styled/Checkbox"
import Triangle from "./styled/Triangle"
import LeftTriangle from "./styled/LeftTriangle"

const POSITION_FROM_TOP = 60
const DEFAULT_TOOLTIP_HEIGHT = 145

class TooltipNotification extends Component {
  static propTypes = {
    popup: PropTypes.object.isRequired,
    showPopUp: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      checked: false,
      position: 0,
      anchor: null,
      topPosition: POSITION_FROM_TOP
    }
  }

  UNSAFE_componentWillMount() {
    window.addEventListener("resize", this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (get(nextProps, "popup.ShowPopUp.show", false)) {
      this.setState({
        anchor: get(nextProps, "popup.ShowPopUp.anchor", false)
      }, this.positionTooltip)
    }
  }

  positionTooltip = () => {
    const elements = document.querySelectorAll(`[data-attach-tooltip='${this.state.anchor}']`)
    if (elements.length === 1) {
      const anchorPosition = elements[0].getBoundingClientRect()
      const position = anchorPosition.left - (
        get(this.props, "popup.ShowPopUp.triangle", false) === "right" ? 180 : 0
      )

      const topPosition = get(this.props, "popup.ShowPopUp.positionVertically", false)
        ? anchorPosition.top + anchorPosition.height + window.scrollY
        : POSITION_FROM_TOP
      this.setState({position, topPosition})
    }
  }

  resize = () => {
    if (get(this.props, "popup.ShowPopUp.show", false)) {
      this.positionTooltip()
    }
  }

  onChange = () => {
    this.setState({
      checked: true
    })
    const onChange = get(this.props, "popup.ShowPopUp.onChange", false)
    if (onChange) {
      onChange()
    } else {
      localStorage.setItem(`${this.state.anchor}TooltipHide`, true)
    }
    setTimeout(() => {
      this.props.showPopUp({show: false})
    }, 1000)
  }

  onClose = () => {
    this.props.showPopUp({show: false})
  }

  render() {
    const {popup} = this.props
    const {position, topPosition, checked} = this.state
    const subtext = get(popup.ShowPopUp, "subtext", false)
    const hideOnMobile = get(popup.ShowPopUp, "hideOnMobile", false)
    const rightPosition = get(this.props, "popup.ShowPopUp.triangle", false) === "right"
    const height = get(this.props, "popup.ShowPopUp.height", DEFAULT_TOOLTIP_HEIGHT)
    const leftTriangle = get(this.props, "popup.ShowPopUp.leftTriangle", false)
    const color = get(this.props, "popup.showPopUp.color", tooltip)
    const triangleProps = {
      bottom: height,
      rightPosition,
      color
    }

    return (
      <PopUpWrapper
        position={position}
        topPosition={topPosition}
        hideOnMobile={hideOnMobile}>
        <TransitionGroup>
          {popup.ShowPopUp && popup.ShowPopUp.show &&
            <CSSTransition
              classNames="tooltipPopup"
              appear
              enter
              timeout={{enter: 1000, exit: 300, appear: 1000}}>
              <PopUp color={color} height={height}>
                {leftTriangle ? <LeftTriangle {...triangleProps} />
                  : <Triangle {...triangleProps} />}
                <Close
                  top="10px"
                  right="10px"
                  color="white"
                  onClick={this.onClose} />
                <H5 color="white" paddingTop={1.5}>{popup.ShowPopUp.text}</H5>
                {subtext &&
                  <Flex justifyContent="center" paddingTop={1}>
                    <Checkbox
                      name="tooltip"
                      color={color}
                      checked={checked}
                      onChange={this.onChange} />
                    <Body small color="white">{subtext}</Body>
                  </Flex>
                }
              </PopUp>
            </CSSTransition>
          }
        </TransitionGroup>
      </PopUpWrapper>)
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    showPopUp: (details) => dispatch(ShowPopUp(details))
  }
}
const mapStateToProps = ({popup}) => {
  return {popup}
}

export default connect(mapStateToProps, mapDispatchToProps)(TooltipNotification)
